var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio-container"},[_vm._t("default"),_c('input',{staticClass:"radio-input",attrs:{"type":"radio","name":_vm.categoryType},on:{"click":_vm.onFilterClicked}}),_c('span',{staticClass:"custom-radio"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }